import { NoOperation } from '@lemon8/web-app-shared/util';
import { FC } from 'react';
import { SwiperTabs } from '~/components/swiper-tab';
import CollectionIcon from 'icon/collection.svg';
import BookMarkIcon from 'icon/bookmark_lock.svg';
import HeartIcon from 'icon/heart_lock.svg';
import { TabBookmark, TabHeart, TabCollection } from './tabs';

import './style.scss';

export const ContentTabs: FC = () => {
  return (
    <section className="user-content">
      <SwiperTabs
        onChange={NoOperation}
        swipeable={true}
        tabs={[
          {
            key: '1',
            value: <CollectionIcon />,
          },
          {
            key: '2',
            value: <BookMarkIcon />,
          },
          {
            key: '3',
            value: <HeartIcon />,
          },
        ]}
      >
        <TabCollection />
        <TabBookmark />
        <TabHeart />
      </SwiperTabs>
    </section>
  );
};
